module.exports = __webpack_public_path__ + "static/village_card_img8@2x-1cadf9b911904d762324561cfe8d830d.png";